import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonTranslateModule } from "../../utils/common-translate.module";
import { UiBackButtonComponent } from "./ui-back-button.component";

const materialModules = [MatButtonModule, MatIconModule];

@NgModule({
  declarations: [UiBackButtonComponent],
  providers: [],
  imports: [CommonModule, CommonTranslateModule, BrowserAnimationsModule, ...materialModules],
  exports: [UiBackButtonComponent],
})
export class UiBackButtonModule {}
